import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/errors";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await forgotPassword(email.trim()); setSent(true); }
    catch (e) { setErr(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-[70vh]">
      <div className="blob blob-gold" style={{ width: 500, height: 500, top: 40, right: -180 }}/>
      <div className="max-w-md mx-auto px-6 py-16 relative">
        <div className="text-center mb-8">
          <div className="uppercase tracking-[0.3em] text-xs text-[#8B7355] mb-3">Reset password</div>
          <h1 className="font-serif-display text-5xl text-[#3B2F2F]">Forgot password?</h1>
          <p className="text-sm text-stone-500 mt-2">We'll send a reset link to your inbox.</p>
        </div>

        {sent ? (
          <div className="bg-white/80 backdrop-blur rounded-3xl border border-stone-200 shadow-xl p-8 text-center" data-testid="forgot-success">
            <div className="text-[#2E4A35] font-semibold mb-2">Check your email ✦</div>
            <p className="text-sm text-stone-500">If an account exists for that email, a reset link is on its way.</p>
            <Link to="/login" className="inline-block mt-6 text-[#8B7355] hover:text-[#3B2F2F] text-sm">← Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white/80 backdrop-blur rounded-3xl border border-stone-200 shadow-xl p-8 space-y-4" data-testid="forgot-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-stone-500">Email</label>
              <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="forgot-email"
                     className="mt-1 w-full bg-stone-50 border border-stone-200 rounded-full px-4 py-3 outline-none focus:border-[#3B2F2F]" />
            </div>
            {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{err}</div>}
            <button type="submit" disabled={busy} data-testid="forgot-submit"
                    className="w-full bg-[#3B2F2F] text-[#FDFBF7] rounded-full py-3 font-semibold hover:bg-black disabled:opacity-60">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/login" className="block text-center text-xs text-[#8B7355] hover:text-[#3B2F2F]">← Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
